import PubSub from "underpub-js";

var BannerSimple = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-BannerSimple',
	};

	$.extend(true, this.options, options);

};

BannerSimple.prototype.init = function() {

	var self = this;

	this.options.$el.find('.banner-button_close-button').on('click', function(e) {
		e.preventDefault();
		self.options.$el.hide();
	});

};

export default BannerSimple;
